import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TopicCardComponent } from './components/topic-card/topic-card.component';
import { VideoCardComponent } from './components/video-card/video-card.component';
import { InteractDirective } from './directives/interact.directive';
import { SubstitutionFieldsComponent } from './components/substitution-fields/substitution-fields.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { LanguageSelectorComponent } from 'src/app/components/language-selector/language-selector.component';
import { TranslateDirective } from 'src/app/directives/translate.directive';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TagModule } from 'primeng/tag';
import { HtmlCodeEditorComponent } from './components/html-code-editor/html-code-editor.component';
import { EmailPreviewFrameComponent } from './components/email-preview-frame/email-preview-frame.component';
import { EmailImportIssuesComponent } from './components/email-import-issues/email-import-issues.component';



@NgModule({
  declarations: [
	TopicCardComponent,
	VideoCardComponent,
	InteractDirective,
	SubstitutionFieldsComponent,
	LanguageSelectorComponent,
	TranslateDirective,
	HtmlCodeEditorComponent,
	EmailPreviewFrameComponent,
	EmailImportIssuesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    SelectButtonModule,
    TagModule,
  ],
  exports: [
	TopicCardComponent,
	VideoCardComponent,
	InteractDirective,
	SubstitutionFieldsComponent,
	LanguageSelectorComponent,
	TranslateDirective,
	HtmlCodeEditorComponent,
	EmailPreviewFrameComponent,
	EmailImportIssuesComponent,
  ]
})
export class SharedModule { }
